import { type ReactElement, useState } from 'react'

import { NOW_PDP_LABEL_CLICK } from 'shared/experiments/consts'
import trackOptimizelyEvent from 'shared/experiments/utils/trackOptimizelyEvent'
import NowLabelWithZipInteraction from 'views/components/molecules/NowLabelWithZipInteraction'
import ProductNowShippingModal from 'views/components/organisms/ProductNowShippingModal'

interface INowLabelWithZipInteractionContainer {
  upid: string
  displayNowWidget: boolean
  price?: number
  productNowEligible: boolean
}

const NowLabelWithZipInteractionContainer: (
  props: INowLabelWithZipInteractionContainer
) => ReactElement = ({
  upid,
  displayNowWidget,
  productNowEligible,
  price = 0,
}) => {
  const [openModal, setOpenModal] = useState(false)
  const [nowEligible, setNowEligible] = useState(productNowEligible)

  return (
    <div data-clientside-hook="h-nowLabelWithZipInteractionContainer">
      <li className="u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer  o-ProductLabels__ProductLabelContainer--now">
        <div
          role="button"
          tabIndex={0}
          onClick={() => {
            setOpenModal(true)
            trackOptimizelyEvent(NOW_PDP_LABEL_CLICK)
          }}
          onKeyDown={undefined}
        >
          <NowLabelWithZipInteraction
            nowEligible={nowEligible}
            displayNowWidget={displayNowWidget}
          />
        </div>
        <ProductNowShippingModal
          id="productNowShippingModal"
          open={openModal}
          upid={upid}
          price={price}
          setModalOpen={setOpenModal}
          nowEligible={nowEligible}
          setNowEligible={setNowEligible}
        />
      </li>
    </div>
  )
}

export default NowLabelWithZipInteractionContainer
